import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { dnaPaginatorIntl } from './shared/providers/paginator-intl';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { NgScrollbarModule } from 'ngx-scrollbar';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { SharedModule } from './shared/shared.module';

import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';

import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {AppRoutingModule} from "./app-routing.module";
import {MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/dialog";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DnaSnackBarService} from "./shared/service/dna-snackbar.service";
import {DateAdapter as MatDateAdapter, MAT_DATE_LOCALE} from "@angular/material/core";
import {BrDateAdapter} from "./shared/utils/br-date-adapter";
import {FormatDocument} from "./shared/utils/format-document.pipe";
import {AuthorizeComponent} from "./theme/components/authorize/authorize.component";
import {TokenInterceptor} from "./shared/interceptor/token.interceptor";
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from "@angular/common";
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

@NgModule({ declarations: [
        AppComponent,
        PagesComponent,
        SidenavComponent,
        VerticalMenuComponent,
        FullScreenComponent,
        ApplicationsComponent,
        UserMenuComponent,
        FavoritesComponent,
        AuthorizeComponent
    ],
    bootstrap: [
        AppComponent
    ], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        SharedModule], providers: [
        AppSettings,
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        // Toasts no padrão SSO: snackBar.open(...) renderiza o banner dna-alert
        { provide: MatSnackBar, useClass: DnaSnackBarService },
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MatDateAdapter, useClass: BrDateAdapter },
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: MatPaginatorIntl, useFactory: dnaPaginatorIntl },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: FormatDocument },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
